export const INCREMENT_INFINITE_SCROLL_PAGE = 'INCREMENT_INFINITE_SCROLL_PAGE';
export const RESET_INFINITE_SCROLL = 'RESET_INFINITE_SCROLL';
export const SET_INFINITE_SCROLL_ITEMS = 'SET_INFINITE_SCROLL_ITEMS';

export function incrementPage(scrollableKey) {
  return {
    type: INCREMENT_INFINITE_SCROLL_PAGE,
    payload: { scrollableKey }
  };
}

export function reset(scrollableKey) {
  return {
    type: RESET_INFINITE_SCROLL,
    payload: { scrollableKey }
  };
}

export function setItems(scrollableKey, items) {
  return {
    type: SET_INFINITE_SCROLL_ITEMS,
    payload: { scrollableKey, items }
  };
}
